export enum ECategory {
    'fruit-and-veg-box' = 'fruit-and-veg-box',
    'veg-box' = 'veg-box',
    'fruit-box' = 'fruit-box',
}
